import EventBase from './EventBase'
import EventID from './EventID'
import {
  ensureAudioFadeParameters,
  readAudioFadeSeconds,
  readAudioFadeTrack,
  writeAudioFadeSeconds,
  writeAudioFadeTrack,
} from './audioEventShared'

/**
 * 508  -  淡出音效
 */

export default class EventFadeBGS extends EventBase {
  /**
   * 淡出音效的构造函数
   */
  constructor() {
    super()
    this.Parameter = ensureAudioFadeParameters(['0', '', '0'])
  }

  // #region 事件内关键属性参数
  /**
   * 时间
   */
  get Time() {
    return readAudioFadeSeconds(this.Parameter)
  }
  set Time(value) {
    this.Parameter = writeAudioFadeSeconds(this.Parameter, value)
  }

  /**
   * 显示信息
   */
  get Description() {
    if (this.Parameter && this.Parameter.length > 1) {
      return this.Parameter[1]
    } else return ''
  }
  set Description(value) {
    this.Parameter = ensureAudioFadeParameters(this.Parameter)
    this.Parameter[1] = value.toString()
  }

  get AudioIndex() {
    return readAudioFadeTrack(this.Parameter)
  }
  set AudioIndex(value) {
    this.Parameter = writeAudioFadeTrack(this.Parameter, value)
  }

  //   // #endregion

  /**
   * 事件ID
   */
  Code = EventID.FadeBGS

  /**
   * 获得该事件在事件列表的描述信息
   */
  /// <returns>事件描述信息</returns>
}
